import React, { useEffect } from "react";
import { RolesModalLayoutJSON } from "../Json/RolesLayoutJson";
import { RolesModalFieldsJSON } from "../Json/RolesFieldsJson";
import { renderElement } from "../../../../../Components/Common/FormRendererV2/Renderer";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import { CardBody } from "reactstrap";
import {
  resetFormState,
  setSelectValidError,
  verifyModal,
} from "../../../../../slices/common/reducer";
import CommonButton from "../../../../../Components/Common/CommonButton/CommonButton";
import ConfirmationModal from "../Modal/ConfirmationModal";
import { getUserData } from "../../Users/UserService";
import { getRolesData, updateRole } from "../RolesService";
import { checkButtonAccess } from "../../../../../Utils/CommonUtils";

const Details = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigator = useNavigate();
  const formState = useSelector((state) => state.common.formRendererState);
  const verifyShow = useSelector((state) => state.common.verifyShow);
  const triggerRender = useSelector((state) => state.common.triggerRender);
  const editMode = !!params.id;

  useEffect(() => {
    if (params.id) {
      getRolesData(params.id, "ROL");
    }
  }, [params.id]);

  const handleCancel = () => {
    dispatch(resetFormState());
    dispatch(setSelectValidError(false));
    navigator("/team/role");
  };

  const updateClickHandler = (e) => {
    e.preventDefault();
    dispatch(verifyModal(true));
  };

  const confirmUpdate = () => {
    if (formState) {
      dispatch(setSelectValidError(false));
      updateRole(formState, params.id, "ROL", navigator);
    } else {
      dispatch(setSelectValidError(true));
    }
    dispatch(verifyModal(false));
  };

  return (
    <div>
      <Form onSubmit={updateClickHandler}>
        <CardBody>
          <div className="selected-tab-bottom-content">
            {RolesModalLayoutJSON.map((element) => (
              <div key={element.elementid}>
                {element.child.map((child) =>
                  renderElement(child, RolesModalFieldsJSON, formState)
                )}
              </div>
            ))}
          </div>
          <div className="form-footer">
            <CommonButton
              update={true}
              checkAccess={checkButtonAccess("EDIT", "TEM_ROL")}
              // handleSubmit={updateClickHandler}
              handleCancel={handleCancel}
            />
          </div>
          {verifyShow && <ConfirmationModal confirmUpdate={confirmUpdate} />}
        </CardBody>
      </Form>

      {/* </form> */}
    </div>
  );
};

export default Details;
